import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect,useState } from 'react';
// import Home from './pages/Home';
// import Services from './pages/Services';
// import About from './pages/About';
// import Contact from './pages/Contact';
// import Login from './pages/Login';
// import Register from './pages/Register';
import Home from './Compontents/Home';
import About from './Compontents/About';
import Footer from './Compontents/Footer';
import Contact from './Compontents/Contact';
import Header from './Compontents/Header';
import Loader from './Compontents/Loder';
import Navbar from './Compontents/Navbar';
import LogoDesgin from './Compontents/LogoDesgin';
import Website from './Compontents/Website';
import Template from './Compontents/Template';
import Login from './Compontents/Login';
import Register from './Compontents/Register';
import Poster from './Compontents/Poster';
import Services from './Compontents/Services';
function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Show spinner for 5 seconds
    const timer = setTimeout(() => {
      setLoading(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  if (loading) return <Loader />;
  return (
  
    <Router>
      <Navbar />
      <div className="content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/logo" element={<LogoDesgin />} />
          <Route path="/services/website" element={<Website />} />
          <Route path="/services/template" element={<Template />} />
          <Route path='/services/poster' element={<Poster/>}/>
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
        </Routes>
      </div>
      <Footer />
    </Router>
  );
}

export default App;
